import { type ProfileOpportunities_userProfile$key } from '#app/__generated__/relay/ProfileOpportunities_userProfile.graphql.js';
import { AllProfileWorkOpportunityResultsListView } from '#app/features/opportunities/components/AllProfileWorkOpportunityResultsListView/AllProfileWorkOpportunityResultsListView.js';
import { WorkTabLayoutContextProvider } from '#app/features/paidProjects/contexts/WorkTabLayoutContext.js';
import { ProfileOpportunitiesWrapper } from './ProfileOpportunities.styles.js';
import { graphql, useFragment } from '@contra/relay';

type ProfileServicesProps = {
  readonly profileKey: ProfileOpportunities_userProfile$key;
};

export const ProfileOpportunities = ({ profileKey }: ProfileServicesProps) => {
  const profile = useFragment<ProfileOpportunities_userProfile$key>(
    graphql`
      fragment ProfileOpportunities_userProfile on UserProfile {
        visitorCanEdit
        firstName
        ...AllProfileWorkOpportunityResultsListView_userAccount
      }
    `,
    profileKey,
  );

  const { visitorCanEdit } = profile;

  return (
    <ProfileOpportunitiesWrapper visitorCanEdit={visitorCanEdit}>
      <WorkTabLayoutContextProvider>
        <AllProfileWorkOpportunityResultsListView
          firstName={profile?.firstName}
          jobPostingsRef={profile}
          visitorCanEdit={visitorCanEdit}
        />
      </WorkTabLayoutContextProvider>
    </ProfileOpportunitiesWrapper>
  );
};
